import React, { useState, useEffect, useRef } from 'react'
import { emitirRelatorio } from '../../../util/AcessoApi'
import { ConsultaRelatorio } from '../../../components/RelatorioPadrao'
import { InputTipoRelatorio, InputSimNao, InputTipoProduto, InputProduto, InputFornecedor } from '../../../components/InputsAutoComplete'
import { InputDatePicker } from '../../../components/Inputs'
import { BotaoPadrao } from '../../../components/Botoes'
import { Formik, Form } from 'formik'
import ContentLoader from 'react-content-loader'
import Yup, { validaData } from '../../../util/Validacoes'
import { Link, useHistory } from 'react-router-dom'


export default props => {
    const history = useHistory();
    const idDevolucao = (history.location.state && history.location.state.id_devolucao) ? history.location.state.id_devolucao : null

    const [filtros, setFiltros] = useState([])
    const [showModalFiltros, setShowModalFiltros] = useState(false)
    const [titulo, setTitulo] = useState('Relatórios de Produtos')
    const [dados, setDados] = useState([])
    const [relatorioSelecionado, setRelatorioSelecionado] = useState(0)
    const [valuesFiltros, setValuesFiltros] = useState({ tipo_relatorio: '' })
    const [relatorioAtual, setRelatorioAtual] = useState({})
    const [carregando, setCarregando] = useState(false)
    const [carregandoFiltros, setCarregandoFiltros] = useState(false)
    const [relatorioDevolucao, setRelatorioDevolucao] = useState({
        titulo: 'Relatório de Devolução',
        tipo: 1,
        url: '/relatorio/relatoriodevolucao',
        classeTr: 'linha-bottom-relatorio',
        colunas: [
            { label: '#', name: '#', visivel: true, width: '1%', alinhamento: 'text-center' },
            { label: 'Cód. Comprovante', name: 'codigo_comprovante', visivel: true, ordenamento: { tipo: 'numero', ativo: false }, width: '7%' },
            { label: 'Cód. Barras', name: 'codigo_barras', visivel: true, ordenamento: { tipo: 'texto', ativo: false, }, width: '9%' },
            { label: 'Nome', name: 'nome', visivel: true, ordenamento: { tipo: 'texto', ativo: false }, width: '26%' },
            { label: 'N° Guia', name: 'n_guia', visivel: true, ordenamento: { tipo: 'texto', ativo: false }, width: '7%' },
            { label: 'Data Proced.', name: 'data_procedimento', visivel: true, ordenamento: { tipo: 'data', ativo: false }, alinhamento: 'text-center', width: '7%' },
            { label: 'Hospital', name: 'hospital', visivel: true, ordenamento: { tipo: 'numero', ativo: false }, width: '7%' },
            { label: 'Tipo Pessoa', name: 'tipo_pessoa', visivel: true, ordenamento: { tipo: 'texto', ativo: false } },
            { label: 'Status', name: 'status', visivel: true, ordenamento: { tipo: 'texto', ativo: false }, width: '15%' },
            { label: 'Executante/Cooperado', name: 'cooperado', visivel: true, ordenamento: { tipo: 'texto', ativo: false }, width: '20%' },
        ],
        data: [],
        numerarLinha: false,
        colunasFiltros: [
            { label: 'Tipo Produto', name: 'tipo_produto', name_coluna: 'tipo_produto' },
            { label: 'Produto', name: 'produto', name_coluna: 'produto' },
            { label: 'Fornecedor', name: 'fornecedor', name_coluna: 'fornecedor' },
            { label: 'Cliente', name: 'cliente', name_coluna: 'cliente' },
            { label: 'Bloqueado? ', name: 'bloqueado', name_coluna: 'bloqueado' },
            { label: 'Data Entrada Inicial', name: 'data', name_coluna: 'data_entrada_inicial' },
            { label: 'Data Entrada Final', name: 'data', name_coluna: 'data_entrada_final' },
        ],
        relatorioEspecifico: (dados, arrayConfigCol, configOrdenamento) => relatorioProdutoPorFornecedor(dados, arrayConfigCol, configOrdenamento)
    })

    useEffect(() => {
        if (idDevolucao) {
            let cloneRelatorioAtual = relatorioDevolucao
            emitirRelatorio(cloneRelatorioAtual.url, cloneRelatorioAtual.titulo, { id_lote: idDevolucao, value: filtros },
                array => {
                    cloneRelatorioAtual.data = array
                    setTitulo(cloneRelatorioAtual.titulo)
                    setDados([{ numerarLinha: cloneRelatorioAtual.numerarLinha !== undefined ? cloneRelatorioAtual.numerarLinha : true, colunas: cloneRelatorioAtual.colunas, data: cloneRelatorioAtual.data, relatorioEspecifico: !!cloneRelatorioAtual.relatorioEspecifico ? (dados, arrayConfigCol, configOrdenamento) => cloneRelatorioAtual.relatorioEspecifico(dados, arrayConfigCol, configOrdenamento) : null }])
                    setRelatorioAtual(cloneRelatorioAtual)
                    setCarregando(false)
                })
        }
    }, [idDevolucao])

    const tipoRelatorio = [
        { label: 'Relatório de Devolução', value: 1 },
    ]

    const validacao = Yup.object({
        data_aniversario_inicial: Yup.string().nullable()
            .test('Data Inicial', 'Data inválida!', function (value) { return validaData(this.parent.data_inicial) }),
        data_aniversario_final: Yup.string().nullable()
            .test('Data Final', 'Data inválida!', function (value) { return validaData(this.parent.data_final) })
    })

    const relatoriosPorTipo = propsFormik => [
        {
            campos: [],
            ...relatorioDevolucao
        },
    ]


    const submit = (values, propsFormik) => {
        setCarregando(true)
        let novoRelatorio = relatoriosPorTipo(propsFormik).find(x => x.tipo === 1)

        if (novoRelatorio.tipo === relatorioAtual.tipo)
            novoRelatorio.colunas = relatorioAtual.colunas

        setShowModalFiltros(false)
        for (let i = Object.keys(values).length; i > 0; i--)
            if (Array.isArray(values[Object.keys(values)[i]]) && values[Object.keys(values)[i]].length === 0 || !values[Object.keys(values)[i]])
                delete values[Object.keys(values)[i]]

        setValuesFiltros(values)
        setRelatorioAtual({ ...novoRelatorio })

        setFiltros(Object.keys(values).map((x, idx, array) => {
            const valorAtual = values[x]

            return (x !== 'tipo_relatorio'
                && (typeof valorAtual === 'string' ? valorAtual : (valorAtual && valorAtual.length ? valorAtual.map(y => y.value).length : (valorAtual && valorAtual.value ? valorAtual.value.length : valorAtual))) &&
            {
                coluna: novoRelatorio.colunasFiltros.find(y => y.name_coluna === x) !== undefined && novoRelatorio.colunasFiltros.find(y => y.name_coluna === x).name_coluna,
                filtro: novoRelatorio.colunasFiltros.find(y => y.name_coluna === x) !== undefined && novoRelatorio.colunasFiltros.find(y => y.name_coluna === x).label,
                name: novoRelatorio.colunasFiltros.find(y => y.name_coluna === x) !== undefined && novoRelatorio.colunasFiltros.find(y => y.name_coluna === x).name,
                value: typeof valorAtual === 'string' ? valorAtual : valorAtual.length ? valorAtual.map(y => y.value) : valorAtual.value,
                dado: typeof valorAtual === 'string' ? valorAtual : valorAtual.length ? valorAtual.map(y => y.label).toString().split(',').join(', ') : valorAtual.label
            })
        }
        ).filter(x => x))
    }

    useEffect(() => {
        let cloneRelatorioAtual = { ...relatorioAtual }

        cloneRelatorioAtual.url &&
            emitirRelatorio(cloneRelatorioAtual.url, cloneRelatorioAtual.titulo, { id_lote: idDevolucao, value: filtros },
                array => {
                    cloneRelatorioAtual.data = array
                    setTitulo(cloneRelatorioAtual.titulo)
                    setDados([{ numerarLinha: cloneRelatorioAtual.numerarLinha !== undefined ? cloneRelatorioAtual.numerarLinha : true, colunas: cloneRelatorioAtual.colunas, data: cloneRelatorioAtual.data, relatorioEspecifico: !!cloneRelatorioAtual.relatorioEspecifico ? (dados, arrayConfigCol, configOrdenamento) => cloneRelatorioAtual.relatorioEspecifico(dados, arrayConfigCol, configOrdenamento) : null }])
                    setRelatorioAtual(cloneRelatorioAtual)
                    setCarregando(false)
                })
    }, [filtros])

    return (
        <ConsultaRelatorio esconderFiltros={true} showModalFiltros={showModalFiltros} setShowModalFiltros={setShowModalFiltros} dados={dados} titulo={titulo} filtros={filtros} setFiltros={setFiltros}
            loading={carregando} limparFiltrosFormik={() => setValuesFiltros({ tipo_relatorio: valuesFiltros.tipo_relatorio })} setRelatorioAtual={setRelatorioAtual} relatorioAtual={relatorioAtual}
            urlVoltar='/devolucao/lote/consulta'>
            <Formik
                initialValues={valuesFiltros}
                enableReinitialize={true}
                validationSchema={validacao}
                onSubmit={(values, propsFormik) => submit(values, propsFormik)}>
                {propsFormik => (<Form>
                    <div className='row'>
                        {relatoriosPorTipo(propsFormik).find(x => x.tipo === 1) && <div style={{ width: '100%' }}>
                            {relatoriosPorTipo(propsFormik).find(x => x.tipo === 1).campos.map(
                                (item, idx, array) => {
                                    if (idx === (array.length - 1)) {
                                        setTimeout(() => {
                                            setCarregandoFiltros(false)
                                        }, 1000)
                                    }
                                    return item
                                }
                            )}
                        </div>}
                        {carregandoFiltros === true ?
                            <ContentLoader speed={2} width='100%' height='400' backgroundColor="#f3f3f3" foregroundColor="#e4e4e4" {...props} >
                                <rect x="12" y="10" rx="3" ry="3" width="170" height="10" />
                                <rect x="12" y="30" rx="3" ry="3" width="355" height="50" />
                                <rect x="12" y="100" rx="3" ry="3" width="170" height="10" />
                                <rect x="12" y="120" rx="3" ry="3" width="355" height="50" />
                                <rect x="12" y="190" rx="3" ry="3" width="170" height="10" />
                                <rect x="12" y="210" rx="3" ry="3" width="355" height="50" />
                                <rect x="12" y="280" rx="3" ry="3" width="170" height="10" />
                                <rect x="12" y="300" rx="3" ry="3" width="355" height="50" />
                            </ContentLoader>
                            : <></>}
                    </div>
                    <div className='direita container-botoes mb-3 group-salvar-novo'>
                        <BotaoPadrao texto='Filtrar' disabled={false} />
                    </div>
                </Form>)}
            </Formik>
        </ConsultaRelatorio>
    )
}

const relatorioProdutoPorFornecedor = (array, arrayConfigCol, configOrdenamento) => {
    return (
        array && array.map((x, idx) =>
            <>
                <table className='table-agrupamento'>
                    {(configOrdenamento.arrayOrdenamento[idx] && configOrdenamento.arrayOrdenamento[idx].filter(item => item === true).length > 0) && <tr><td colspan={`${x.colunas ? x.colunas.filter(y => y.visivel).length : 0}`}
                        className={'bold'}><Link to='#' className='d-none-print' onClick={() => configOrdenamento.limparOrdenamentos(idx)}>Remover ordenamentos</Link></td></tr>}
                </table>
                {
                    x.data && x.data.comprovantes && x.data.comprovantes.map((coan, idxCoan) => {
                        return (<>
                            <table className={'table-agrupamento mb-1 ' + (idxCoan === 0 ? '' : 'd-block-print')}>
                                <tr className={''}>
                                    <td colspan={x.colunas.length}>
                                        <div style={{ display: 'flex' }}>
                                            <span style={{ flex: 10 }}>{x.data.lote.cooperado}</span>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <table className='table-agrupamento mb-5'>
                                <tr className="group-title">
                                    {x.colunas && x.colunas.map((y, idy) => {
                                        let classes = (y.ordenamento ? 'ordenavel ' : '') + (arrayConfigCol[idx][idy] && arrayConfigCol[idx][idy].ordenamento.ativo && arrayConfigCol[idx][idy].coluna === y.name ? 'ordenamento_' + arrayConfigCol[idx][idy].ordenamento.modo : '');
                                        return (arrayConfigCol[idx][idy] && arrayConfigCol[idx][idy].visivel) && <td onClick={(event) => {
                                            if (y.ordenamento)
                                                configOrdenamento.setOrdenamento(idy, x.data, idx)
                                        }} style={{ width: y.width || 'auto' }} className={`bold coluna ${y.alinhamento && y.alinhamento || ''} ${classes}`}>{y.label}</td>
                                    })}
                                </tr>

                                <tr className={'titulo-1'}>
                                    <td colspan={x.colunas.length}>
                                        <div style={{ display: 'flex' }}>
                                            <span style={{ flex: 10 }}>{coan.convenio}</span>
                                        </div>
                                    </td>
                                </tr>

                                <tr><td colspan={x.colunas.length}><span></span></td> </tr>
                                {
                                    coan.comprovantes.length ?
                                        <>
                                            {
                                                configOrdenamento.arrayOrdenamento ? configOrdenamento.obterDataOrdenado(idx, coan.comprovantes).map((comprovante, idxC) => {
                                                    return (
                                                        <tr className={`td-data`}>
                                                            {arrayConfigCol[idx].findIndex(name => name.coluna === '#' && name.visivel) > -1 && <td className={'text-center'}>{idxC + 1}</td>}
                                                            {arrayConfigCol[idx].findIndex(name => name.coluna === 'codigo_comprovante' && name.visivel) > -1 && <td>{comprovante.codigo_comprovante}</td>}
                                                            {arrayConfigCol[idx].findIndex(name => name.coluna === 'codigo_barras' && name.visivel) > -1 && <td>{comprovante.codigo_barras}</td>}
                                                            {arrayConfigCol[idx].findIndex(name => name.coluna === 'nome' && name.visivel) > -1 && <td>{comprovante.nome}</td>}
                                                            {arrayConfigCol[idx].findIndex(name => name.coluna === 'n_guia' && name.visivel) > -1 && <td>{comprovante.n_guia}</td>}
                                                            {arrayConfigCol[idx].findIndex(name => name.coluna === 'data_procedimento' && name.visivel) > -1 && <td className={'text-center'}>{comprovante.data_procedimento}</td>}
                                                            {arrayConfigCol[idx].findIndex(name => name.coluna === 'hospital' && name.visivel) > -1 && <td>{comprovante.hospital}</td>}
                                                            {arrayConfigCol[idx].findIndex(name => name.coluna === 'tipo_pessoa' && name.visivel) > -1 && <td>{comprovante.tipo_pessoa}</td>}
                                                            {arrayConfigCol[idx].findIndex(name => name.coluna === 'status' && name.visivel) > -1 && <td>{comprovante.status}</td>}
                                                            {arrayConfigCol[idx].findIndex(name => name.coluna === 'cooperado' && name.visivel) > -1 && <td>{comprovante.cooperado}</td>}
                                                        </tr>)
                                                }) : <></>
                                            }
                                        </>
                                        : <></>
                                }
                            </table>
                            {idxCoan === x.data.comprovantes.length - 1 ? <table className={'table-agrupamento mt-100 d-block-print ' + (idxCoan === x.data.comprovantes.length - 1 ? '' : '')}>
                                <tr className={''}>
                                    <td colspan={x.colunas.length} className='text-center'>
                                        <div style={{ display: 'flex' }}>
                                            <span style={{ flex: 10 }}>{'_______________________________________________________'}</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr className={''}>
                                    <td colspan={x.colunas.length} className='text-center'>
                                        <div style={{ display: 'flex' }}>
                                            <span style={{ flex: 10 }}>{'Cooperado/Responsável'}</span>
                                        </div>
                                    </td>
                                </tr>
                                { x.data.lote.data_devolucao ? <> <tr className={''}>
                                    <td colspan={x.colunas.length} className='text-left'>
                                        <div style={{ display: 'flex' }}>
                                            <span style={{ flex: 10 }}>{'Entregue em: ' + x.data.lote.data_devolucao}</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr className={''}>
                                    <td colspan={x.colunas.length} className='text-left'>
                                        <div style={{ display: 'flex' }}>
                                            <span style={{ flex: 10 }}>{'Responsável: ' + x.data.lote.responsavel}</span>
                                        </div>
                                    </td>
                                </tr> </> : <></>}
                            </table>
                            : <></>}
                            
                        </>
                        )
                    })
                }
            </>
        )
    )
}